module.exports = __webpack_public_path__ + "static/media/puzzle_icon.f4282de2.svg";